import { ICrop } from "../omnia"

export interface IFieldSelectionViewModel {

    id: string

    fieldId: number
    fieldName: string

    zoneId: number
    zoneNumber: number

    description: string

    currentCrop: ICrop
    previousCrop: ICrop

    analysisNumber: string
    analysisDate: Date

    selected: boolean

}

export enum OrderStep {
    FieldSelection = 1,
    FormInput = 2
}

